import React, { Component, PropTypes } from 'react';
import { merge, omit, get, find } from 'lodash';

import {getSchema as getJobSchema} from '../../../../../../models/jobRequest';

import { validateField } from '../../../../../../modelValidator';

import TextField from '../../../../../../common/components/c_TextField';
import ToggleButton from '../../../../../../common/components/c_ToggleButton';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import cx from 'classnames';
import {parentChildList} from '../../../../../../lib/parentChildList';
import { JOB_REQUEST_STATUS } from '../../../../../../common/enums';

const yesNo = [{value: true, primaryText: 'Yes', subElement: 'localJobDetails'}, {value: false, primaryText: 'No', subElement: null}];

export default class PositionSection extends Component {

  static propTypes = {
    jobRequest: PropTypes.object.isRequired,
    staticData: PropTypes.object,
    labels    : PropTypes.object,
    handleSave: PropTypes.func,
    disabled  : PropTypes.bool
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      dirty: false,
      jobRequestModel: this.props.jobRequest
    };

    this.parentChildHandlers = parentChildList();

  }

  handleChange = (prop) => {
    return (event, value) => {
      const jobRequest = this.state.jobRequestModel;
      jobRequest[prop] = value;
      this.setState(merge({}, this.state, {jobRequestModel: jobRequest, stateSaved:false, dirty: true}));
    };
  }

  handleUI = (prop, label) => {
    return {
      'data-id': prop,
      value: this.state.jobRequestModel[prop],
      errorText: this.state.isDirty && getJobSchema().position[prop] !== undefined ? validateField(this.state.jobRequestModel[prop], getJobSchema().position[prop])[0] : undefined,
      onChange: this.handleChange(prop),
      floatingLabelText: label || null,
      isDirty: this.state.isDirty,
      disabled: this.props.disabled,
    };
  }

  handleUIDropdown = (prop, label, menuItems) => {
    return {
      menuItems,
      ...this.handleUI(prop, label)
    };
  }

  handleSave() {

    if(this.state.dirty === false) {
      return;
    }

    this.props.handleSave({
        jobrequest: omit(this.state.jobRequestModel, ['primaryContact', 'jobRequestStatus'])
      }).then(() => {
        this.setState({dirty: false});
      })
    ;
  }

  render() {

    const {parent: industryTypeProps, child: segmentTypeProps} = this.parentChildHandlers({
      parentProps: this.handleUIDropdown('industryTypeId', this.props.labels.industryTypeId, this.props.staticData.industryTypesList),
      childProps: this.handleUIDropdown('segmentTypeId', 'Industry Segment',  this.props.staticData.jobRequestSegmentTypes),
   });

    const isInNewRequestStatus = this.props.jobRequest.jobRequestStatus === JOB_REQUEST_STATUS.NEW_REQUEST ? true : false;
    const disabled = isInNewRequestStatus || this.props.disabled;

    const segmentTypes = get(this.props.staticData, 'jobRequestSegmentTypes').filter(type => !type.hide);
    const otherSegmentType = get(find(segmentTypes, {name: 'Other'}), 'id');

    const industryTypes = get(this.props.staticData, 'industryTypesList').filter(type => !type.hide);
    const otherIndustryType = get(find(industryTypes, {name: 'Other'}), 'id');

    return (
      <div className='job-request-worksheet-position-section'>
        <h1 className='heading'>Position Information</h1>
        <div className='form'>
          <div className='field'>
            <DropDownMenu data-id='question-dropdown-industry-type'
              {...industryTypeProps}
              disabled={disabled}
              />
          </div>

          {
						!!(this.state.jobRequestModel.industryTypeId && this.state.jobRequestModel.industryTypeId === otherIndustryType)
						&&
            <div className='field'>
              <TextField
                floatingLabelFixed
                {...this.handleUI('industryOther', `${this.props.labels.industryTypeId} Other`)}/>
            </div>
          }

          <div className='field'>
            <DropDownMenu data-id='question-dropdown-segment-type'
              {...segmentTypeProps}
              disabled={disabled}
           />
          </div>
          {!!(this.state.jobRequestModel.segmentTypeId && this.state.jobRequestModel.segmentTypeId === otherSegmentType)
						&&
            <div className='field'>
              <TextField
                className='center-column-1'
                floatingLabelText='Industry Segment Other'
                floatingLabelFixed
                {...this.handleUI('segmentOther', 'Other, Please Specify')}
              />
            </div>
          }
          <div className='field'>

            <div className='form-inner'>

                <div className='field-inner grow-2'>
                  <DropDownMenu data-id='question-dropdown-position-type'
                    {...this.handleUI('positionTypeId', 'Position Title')}
                    disabled={disabled}
                    menuItems={this.props.staticData.positionTypes}
                    />
                </div>
                <div className='field-inner'>
                  <TextField className='number-people'
                    {...this.handleUI('numberOfPeople', '# of Openings')}
                    />
                </div>

            </div>

          </div>

          {
            get(this.props, 'labels.licenseRequired', true) &&
            <div className='field'>
              <ToggleButton
                menuItems={yesNo}
                {...this.handleUI('licenseRequired', 'License Required')}
              />
            </div>
          }
          <div className='field'>
            <ToggleButton
              menuItems={yesNo}
              {...this.handleUI('outsideContactRequired', 'Client Phone Contact')}
            />
          </div>
          <div className='field'>
            <ToggleButton
              menuItems={yesNo}
              {...this.handleUI('dualMonitorsRequired', 'Dual Monitors')}
            />

        </div>

      </div>

      {this.props.disabled ? null :  <div>
            <FlatButton
              className={cx('button-save', {disabled: !this.state.dirty})}
              onClick={() => this.handleSave() } data-id='save' label='save' />
        </div>}

    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Profile/PositionSection/index.js